<script setup lang="ts">
const ios = ref(true);

onMounted(() => {
    ios.value =
        !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
});

function openWebAppModal() {
    const WebApplicationModal = defineAsyncComponent(
        () => import('./WebApplicationModal.vue')
    );
    const { open } = useModal({
        component: WebApplicationModal,
        attrs: {},
    });
    open();
}
</script>
<template>
    <div class="download-app-buttons">
        <template v-if="ios">
            <a
                class="download-button"
                target="_blank"
                href="https://trc.metrix.ir/usrc6r/"
                rel="nofollow noopener noreferrer"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/Iapps.svg"
                    alt="iapps"
                    :width="135"
                    :height="40"
                />
            </a>
            <a
                class="download-button"
                target="_blank"
                href="https://trc.metrix.ir/w0oq8r/"
                rel="nofollow noopener noreferrer"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/SipIrani.svg"
                    alt="sibirani"
                    :width="135"
                    :height="40"
                />
            </a>
            <a
                class="download-button"
                target="_blank"
                href="https://trc.metrix.ir/gexgbo/"
                rel="nofollow noopener noreferrer"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/SibApp.svg"
                    alt="sibapp"
                    :width="135"
                    :height="40"
                />
            </a>
            <a
                class="download-button"
                target="_blank"
                rel="nofollow noopener noreferrer"
                @click="openWebAppModal"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/web.svg"
                    alt="pwa"
                    :width="135"
                    :height="40"
                />
            </a>
        </template>
        <template v-else>
            <a
                class="download-button"
                target="_blank"
                href="https://trc.metrix.ir/gexgbo/"
                rel="nofollow noopener noreferrer"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/Cafebazaar.svg"
                    alt="bazaar"
                    :width="135"
                    :height="40"
                />
            </a>
            <a
                class="download-button"
                target="_blank"
                href="https://trc.metrix.ir/wl9w5e/"
                rel="nofollow noopener noreferrer"
            >
                <mr-lazy-img
                    class="download-image"
                    src="/img/download-app/myket.svg"
                    alt="myket"
                    :width="135"
                    :height="40"
                />
            </a>
        </template>
    </div>
</template>

<style lang="scss" scoped>
.download-app-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
    z-index: 10;
}

.download-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 135px;
    height: 40px;
    border-radius: 4px;
}

.download-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
}
</style>
